import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authService.isAuthenticated) {
    authService.logout();
    router.navigate(['acceder/iniciar-sesion']);
    return false;
  }
  return true;
};
